"use strict";

exports.__esModule = true;
exports.statusSelector = exports.sessionSelector = exports.profileSelector = exports.errorSelector = exports.authSelector = exports.accessTokenSelector = void 0;
var _selectors = require("../selectors");
var _constants = require("./constants");
var authSelector = exports.authSelector = (0, _selectors.createSelector)(function (state) {
  return state.auth;
}, function (auth) {
  return auth;
});
var statusSelector = exports.statusSelector = (0, _selectors.createSelector)(authSelector, function (auth) {
  return auth.status;
});
var errorSelector = exports.errorSelector = (0, _selectors.createSelector)(authSelector, function (auth) {
  return auth.error;
});
var sessionSelector = exports.sessionSelector = (0, _selectors.createSelector)(authSelector, function (auth) {
  return auth.session;
});
var accessTokenSelector = exports.accessTokenSelector = (0, _selectors.createSelector)(sessionSelector, function (session) {
  return session != null ? session.accessToken : null;
});
var profileSelector = exports.profileSelector = (0, _selectors.createSelector)(sessionSelector, function (session) {
  if (session && session.idTokenPayload) {
    return Object.entries(session.idTokenPayload).reduce(function (acc, _ref) {
      var key = _ref[0],
        value = _ref[1];
      if (key.startsWith(_constants.CUSTOM_CLAIM_NAMESPACE)) {
        acc[key.replace(_constants.CUSTOM_CLAIM_NAMESPACE, '')] = value;
      } else if (_constants.PROFILE_CLAIM_WHITELIST.includes(key)) {
        acc[key] = value;
      }
      return acc;
    }, {});
  }
  return null;
});